<template>
  <div>
    <el-row class="row">
      <el-input
      placeholder="请输入deivceName"
      v-model="deviceNameInput"
      @focus="inputFocus"
      @blur="inputBlur"
      :class="[active ? 'active' : '', 'deivce-input' ]"
      @keyup.13.native="deviceHandlerKeyUp"
      >
        <el-button slot="append" icon="el-icon-search" @click="clickHandler('deviceNameInput')" ></el-button>
      </el-input>
      <el-input
      placeholder="请输入批次ID"
      v-model="idInput"
      @focus="inputFocus"
      @blur="inputBlur"
      :class="active ? 'active' : '' "
      @keyup.13.native="idHandlerKeyUp"
      >
        <el-button slot="append" icon="el-icon-search" @click="clickHandler('idInput')" ></el-button>
      </el-input>
    </el-row>
    <!-- table表格 -->
    <el-table
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      :data="deviceList"
      class="table"
      @filter-change="filterChange"
      style="margin-bottom:20px">
      <el-table-column
        prop="deviceName"
        label="DeviceName"
        width="180">
      </el-table-column>
      <el-table-column
        prop="productKey"
        label="设备所属产品">
      </el-table-column>
      <el-table-column
        prop="strategyId"
        label="升级批次ID">
      </el-table-column>
      <el-table-column
        prop="deviceVersion"
        label="当前版本号">
      </el-table-column>
      <el-table-column
        prop="upgradeStatus"
        column-key="upgradeStatus"
        :filter-multiple="false"
        :filters="tableFilterData"
        filter-placement="bottom-end"
        label="状态">
          <template slot-scope="scope">
          <span class="tip" :style="{background:(scope.row.upgradeStatus === 0 ? '#888888': scope.row.upgradeStatus === 1 ? '#0070cc': scope.row.upgradeStatus === 2 ? 'yellow': scope.row.upgradeStatus === 3 ? 'green' : scope.row.upgradeStatus === 4 ? 'red': scope.row.upgradeStatus === 5 ? '#ff8a00' : '')}"></span>

          <span style="margin-right: left">{{ scope.row.upgradeStatus === 0 ? '待推送': scope.row.upgradeStatus === 1 ? '已推送': scope.row.upgradeStatus === 2 ? '升级中': scope.row.upgradeStatus === 3 ? '升级成功' : scope.row.upgradeStatus === 4 ? '升级失败': scope.row.upgradeStatus === 5 ? '已取消' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="upgradeStep"
        align="center"
        label="升级进度">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="状态更新时间">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="view(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页管理 -->
    <Paging :total="total" @changePage="changePage"/>
  </div>
</template>
<script>
import Paging from '@/components/paging'
import { getDeviceByFirmwareId } from '@/api/productControl'
export default {
  props: {
    firmwareData: {
      type: Object,
      default: function () {
        return ''
      }
    }
  },
  components: {
    Paging
  },
  watch: {
    deviceNameInput: function (val) {
      if (val === '') {
        this.listQuery.page = 1
        this.reqParams.deviceName = val
        this.getDeviceList()
      }
    },
    idInput: function (val) {
      if (val === '') {
        this.listQuery.page = 1
        this.reqParams.strategyId = ''
        this.getDeviceList()
      }
    }
  },
  data () {
    return {
      deviceNameInput: '',
      idInput: '',
      active: false,
      deviceList: [],
      // 分页功能
      total: 0, // 到时候从后台获取
      listLoading: false, // 根据loading来进行显示/隐藏
      listQuery: {
        page: 1,
        limit: 10
      },
      reqParams: {
        firmwareId: this.firmwareData.firmwareId // 必传
      },
      tableFilterData: [
        { text: '待推送', value: 0 },
        { text: '已推送', value: 1 },
        { text: '升级中', value: 2 },
        { text: '升级成功', value: 3 },
        { text: '升级失败', value: 4 },
        { text: '已取消', value: 5 }
      ]
    }
  },
  created () {
  },
  mounted () {
    this.getDeviceList()
  },
  methods: {
    // 重新加载
    reLoad () {
      window.location.reload()
    },
    // 查看
    view (row) {
      row.firmwareId = this.firmwareData.firmwareId
      this.$router.push({
        path: '/SystemOper/firmwareBatchDetail',
        query: ({ row: JSON.stringify(row) })
      })
    },
    getDeviceList () {
      if (this.reqParams.deviceName === '') {
        delete this.reqParams.deviceName
      }
      if (this.reqParams.strategyId === '') {
        delete this.reqParams.strategyId
      }
      this.reqParams.pageNum = this.listQuery.page
      this.reqParams.pageSize = this.listQuery.limit
      const params = {
        params: this.reqParams
      }
      getDeviceByFirmwareId(params)
        .then(e => {
          if (e.data.data.total <= 15) this.listLoading = true
          e.data.data.list.forEach((ele) => {
            if (ele.upgradeStatus === 3) {
              ele.upgradeStep = '100%'
            } else if (ele.upgradeStatus === 2) {
              ele.upgradeStep = ele.upgradeStep + '%'
            } else {
              ele.upgradeStep = '-'
            }
          })
          this.deviceList = e.data.data.list
          this.total = e.data.data.total
        })
    },
    filterChange (filters) {
      if (filters.upgradeStatus) {
        this.reqParams.upgradeStatus = filters.upgradeStatus[0]
      }
      this.getDeviceList()
    },
    // 输入框聚焦
    inputFocus () {
      this.active = true
    },
    // 输入框失焦
    inputBlur () {
      this.active = false
    },
    // 13键
    deviceHandlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.listQuery.page = 1
        this.clickHandler('deviceNameInput')
      }
    },
    idHandlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.listQuery.page = 1
        this.clickHandler('idInput')
      }
    },
    // 搜索功能
    clickHandler (val) {
      if (val === 'deviceNameInput') {
        this.listQuery.page = 1
        this.reqParams.deviceName = this.deviceNameInput
        this.reqParams.strategyId = this.idInput
        this.getDeviceList()
      }
      if (val === 'idInput') {
        this.listQuery.page = 1
        this.reqParams.strategyId = this.idInput
        this.reqParams.deviceName = this.deviceNameInput
        this.getDeviceList()
      }
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getDeviceList()
    }
  }
}
</script>

<style lang='less' scoped>
  .row{
    margin-bottom: 20px;
    .el-button{
      border-radius: 0;
    }
    .deivce-input{
      margin-left: 0 !important;
    }
    .el-input{
      box-sizing: border-box !important;
      width: 20%;
      margin-left: 10px;
      border: 1px solid #dedede;
      transition: all .3s ease-out;
      -webkit-transition: all .3s ease-out;
      /deep/ .el-input__inner{
        border: none !important;
        height: 38px;
        line-height: 38px;
      }
      /deep/ .el-input-group__append{
        background-color: white !important;
        color: #555 !important;
        border: none !important;
      }
      /deep/ .el-icon-search{
        color: orange;
        font-size: 20px;
        font-weight: bold;
      }
    }

    .active{
      border-color: #737373;
      transition: all .3s ease-out;
      -webkit-transition: all .3s ease-out;
    }
    .el-input:hover{
      border-color: #737373;
      transition: all .3s ease-out;
      -webkit-transition: all .3s ease-out;
    }
  }
  .tip{
      height: 8px;
      width: 8px;
      border-radius: 50%;
      background: #888;
      display: inline-block;
      margin-right: 8px;
    }
</style>
